import { Component, OnInit } from '@angular/core';
import { FunctionService } from '../_services/function.service';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-functions',
  templateUrl: './functions.component.html',
  styleUrls: ['./functions.component.css']
})
export class FunctionsComponent implements OnInit {

  hammeddeler:any[]=[];
  filteredhammeddeler:any[]=[];
  page=1;
  constructor(
    private functionservice:FunctionService,
   
    private toastr: ToastrService) { }
  @BlockUI('changelog') blockUIChangelog: NgBlockUI;
  ngOnInit() {
    this.getHammaddeler(this.page);
  }


  getHammaddeler(page:number){
    this.blockUIChangelog.start('Loading..');
    this.functionservice.getAllergens().subscribe(res=>{
      this.hammeddeler=res;
      this.filteredhammeddeler=res;
      this.blockUIChangelog.stop();
    },err=>{
      this.blockUIChangelog.stop();
    });
  }


}
